<script>
    import GeneralDetailPage from "./GeneralDetailPage.svelte";
    import { _ } from "svelte-i18n";
    import { getEntity } from "../api-client";
    import YouTube from "svelte-youtube";
    import LoadingSquare from "../common/LoadingSquare.svelte";

    export let params = {};
    $: if (params.id) {
        window.scrollTo(0, 0);
    }
    $: videoId = params.id;

    $: video = getEntity("video", videoId);
</script>

{#await video}
    <LoadingSquare />
{:then video}
    <GeneralDetailPage
        title={video.title}
        description={video.description ?? ""}
    >
        <div slot="preTitleArea">
            <div class="headline-xs pretitle">{$_("video_title")}</div>
        </div>

        <div slot="titleImage" class="video-container">
            {#if video.videoUrl}
                <video width="100%" height="100%" controls>
                    <source src={video.videoUrl} type="video/mp4" />
                    Video not supported
                </video>
            {:else if video.videoId}
                <YouTube
                    videoId={video.videoId}
                    width="100%"
                    height="100%"
                    class="video"
                    options={{
                        height: "100%",
                        width: "100%",
                    }}
                />
            {/if}
        </div>
    </GeneralDetailPage>
{:catch}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}

<style>
    :global(.video) {
        position: relative !important;
    }

    .video-container {
        position: relative;
    }

    @media (min-width: 1440px) {
        .video-container {
            padding: 0 16px;
        }

        .pretitle {
            font-size: 24px;
        }
    }
</style>
